import isEmpty from 'lodash/isEmpty'
import React from 'react'
import 'react-awesome-query-builder/lib/css/styles.css'
import 'react-awesome-query-builder/lib/css/compact_styles.css'
import './styles.css'
import { JsonViewer } from '@ztechapps/webui.util'
import { useConfig } from './useConfig'
import { Query, Builder, Utils as QbUtils } from 'react-awesome-query-builder'
import { hasWindow, jsonTryParse } from '@ztechapps/common.utils'

const defaultValue = { id: QbUtils?.uuid?.(), type: 'group' }

export const QueryBuilderInput = ({ value, onChange, config, timeZone = 'America/Chicago' }: any) => {
  const { newConfig } = useConfig({ config, timeZone })

  if (!hasWindow()) return null
  if (!config) return null

  //the value contains the immutable tree and mongodb results
  if (!isEmpty(value?.value)) {
    value = jsonTryParse(value?.value)
  } else if (!isEmpty(value)) {
    value = jsonTryParse(value)
  } else {
    value = defaultValue
  }

  //intentional to support of ssr
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [tree, setTree] = React.useState(QbUtils.checkTree(QbUtils.loadTree(value), newConfig))

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [mongodbValue, setMongodbValue] = React.useState(QbUtils.mongodbFormat(tree, newConfig))

  const _onChange = (immutableTree, newConfig) => {
    setTree(immutableTree)
    const _mongodbValue = QbUtils.mongodbFormat(immutableTree, newConfig)
    setMongodbValue(_mongodbValue)

    if (onChange) {
      onChange({ value: immutableTree, mongodbValue: _mongodbValue })
    }
  }

  const renderBuilder = (props) => (
    <div className="query-builder-container">
      <div className="query-builder qb-lite">
        <Builder {...props} />
      </div>
    </div>
  )

  return (
    <>
      <div>
        <Query {...newConfig} value={tree} onChange={_onChange} renderBuilder={renderBuilder} />
      </div>
      <div>
        <JsonViewer data={mongodbValue} />
      </div>
    </>
  )
}
